export const errorMapping = [
  {
    pattern: /^Failed to send billing emails: Company not found$/,
    key: "billingNotes.errors.companyNotFound"
  },
  {
    pattern: /^Failed to send billing emails: Company and its subsidiaries with no withdrawals this period$/,
    key: "billingNotes.errors.noWithdrawals"
  },
  {
    pattern: /^Failed to send billing emails: Cannot generate the Payroll file, the cycle is open. Company: .*, date: .*$/,
    key: "billingNotes.errors.openCycleError"
  },
  {
    pattern: /^.* must be in YYYY-MM format$/,
    key: "billingNotes.errors.periodFormatError"
  },
  {
    pattern: /^.* must be a valid email$/,
    key: "billingNotes.errors.invalidEmail"
  },
  {
    pattern: /^Failed to send billing emails: sendPayroll disabled$/,
    key: "billingNotes.errors.disabledSendPayrollError"
  }
];

export function numberToCountryCurrency(value, country) {
  const COUNTRY_INFO = {
    'CHL': {
      code: 'es-CL',
      currency: 'CLP'
    },
    'COL': {
      code: 'es-CO',
      currency: 'COP'
    },
    'PER': {
      code: 'es-PE',
      currency: 'PEN'
    },
    'MEX': {
      code: 'es-MX',
      currency: 'MXN'
    }
  };
  const defaultCountry = 'CHL';

  const countryInformation = COUNTRY_INFO[country] || COUNTRY_INFO[defaultCountry]; 
  return new Intl.NumberFormat(countryInformation.code, {
    style: 'currency',
    currency: countryInformation.currency
  }).format(value);
}
